export const PAGE_LABELS = {
  dashboard: "Dashboard & Applications",
  candidates: "Candidates",
  jobPosting: "Job Posting",
  profile: "Profile",
  teamChat: "Team Chat",
  teamMates: "Team",
  accountSettings: "Account Settings",
  manageProfiles: "Manage Profiles",
  emailTemplate: "Email Templates",
  dailyReport: "Daily Report",
  bid: "Bid / Auto Bid / Resume Preview",
  analyze: "Analyze",
  statistic: "Team Statistic",
  personalStatistic: "Statistic",
  interview: "AI Interview",
  calls: "Interviews",
  teamCalls: "Team Interviews",
  calendar: "Calendar",
  teamCalendar: "Team Calendar",
  prompt: "AI Prompt",
  screenshots: "Screenshots",
  billing: "Billing",
  specialActions: "Special Actions (AI, Copy & Messages)",
  jobBoardSettings: "Job Board Settings",
};

export const PAGE_DESCRIPTIONS = {
  dashboard:
    "Dashboard summarizes your work, while Applications tracks submitted roles and their current status.",
  candidates: "Candidates lets you review and manage candidate records.",
  jobPosting:
    "Job Posting is where authorized users create and manage published positions.",
  profile:
    "Profile stores your resume and cover-letter DOCX templates, prompts, and employment preferences.",
  teamChat:
    "Team Chat keeps conversations with your teammates in one workspace.",
  teamMates: "Team shows the people working in your organization.",
  accountSettings:
    "Account Settings manages your personal details, country, and timezone.",
  manageProfiles:
    "Manage Profiles lets authorized users maintain team member profiles and access.",
  emailTemplate:
    "Email Templates controls reusable messages for application communication.",
  dailyReport: "Daily Report records and reviews daily work updates.",
  bid: "Build Resume creates an AI-tailored draft from a job description, then produces documents from your uploaded templates.",
  analyze:
    "Analyze helps you review opportunities and avoid duplicate company submissions.",
  statistic:
    "Team Statistic reports application and interview performance across the team.",
  personalStatistic:
    "Statistic shows your personal application and interview performance.",
  interview: "AI Interview provides an assisted interview workspace.",
  calls: "Interviews manages your scheduled interview activity.",
  teamCalls: "Team Interviews shows interview activity across your team.",
  calendar: "Calendar displays your personal interview schedule.",
  teamCalendar: "Team Calendar displays scheduled activity across the team.",
  prompt: "AI Prompt manages shared instructions used by AI features.",
  screenshots: "Screenshots provides authorized activity monitoring.",
  billing: "Billing shows your balance, usage, and transaction history.",
  jobBoardSettings:
    "Job Board Settings configures the external Job Board connection.",
};

export const getRoleHome = (role, permissions = []) => {
  if (permissions.includes("dashboard")) return "/dashboard";
  if (permissions.includes("candidates")) return "/candidate";
  if (permissions.includes("jobPosting")) return "/job-posting";
  if (permissions.includes("personalStatistic")) return "/personal-statistic";
  if (permissions.includes("accountSettings")) return "/account-settings";
  return "/unauthorized";
};

export const getRolePermissions = (roles = [], roleNumber) =>
  roles.find(({ role }) => Number(role) === Number(roleNumber))?.permissions ||
  [];

export const getEffectivePermissions = (user = {}, roles = []) =>
  Array.isArray(user.page_permissions)
    ? user.page_permissions
    : getRolePermissions(roles, user.role);
